import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";

// Fetch all orders
export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (_, { rejectWithValue }) => {
    try {
      const authData = getAuthData();

      if (!authData?.token || !authData?.groupCode || !authData?.companyCode) {
        throw new Error("signin");
      }
      const formData = new FormData();
      formData.append("token", authData?.token);
      formData.append("company", authData?.company);
      formData.append("aux", authData?.aux);

      const response = await fetch(
        process.env.REACT_APP_API_URL + "clientPortal/Order_History",
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch orders history");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch orders history");
    }
  },
);

// Fetch order details
export const fetchOrderDetail = createAsyncThunk(
  "orders/fetchOrderDetail",
  async (order_id, { rejectWithValue }) => {
    try {
      const authData = getAuthData();

      if (!authData?.token || !authData?.groupCode || !authData?.companyCode) {
        throw new Error("signin");
      }
      const formData = new FormData();
      formData.append("token", authData?.token);
      formData.append("company", authData?.company);
      formData.append("aux", authData?.aux);
      formData.append("order_id", order_id);

      const response = await fetch(
        process.env.REACT_APP_API_URL + "clientPortal/Order_Detail",
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch order details");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    items: [], // List of all orders
    status: "idle", // Status for orders list
    error: null, // Error for orders list
    detail: null, // Order details
    detailStatus: "idle", // Status for order details
    detailError: null, // Error for order details
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch orders list
      .addCase(fetchOrders.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      })

      // Fetch order details
      .addCase(fetchOrderDetail.pending, (state) => {
        state.detailStatus = "loading";
      })
      .addCase(fetchOrderDetail.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.detail = action.payload;
      })
      .addCase(fetchOrderDetail.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.detailError = action.payload || action.error.message;
      });
  },
});

export default ordersSlice.reducer;
